import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/LoginSocialBar' /* webpackChunkName: "LoginSocialBar" */),
    import(
      './viewer/LoginSocialBar.controller' /* webpackChunkName: "LoginSocialBar" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('LoginSocialBar', UiTypes),
};

export default entry;
